





























































































import { EmploymentStatus, NatureOfBusiness, Role, SourceOfFunds, Income, Savings } from "@/constants/form-values";
import { FieldInterface } from "@/types.d.ts";
import { SET_PROGRESS } from "@/constants/mutation-types";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import Select from "@/components/basic/fields/Select.vue";
import Popup from "@/components/basic/Popup.vue";
import Vue from "vue";

export default Vue.extend({
  name: "riskAssessment",
  data() {
    return {
      formData: {
        employmentStatus: "",
        natureOfBusiness: "",
        position: "",
        sourceOfFunds: "",
        income: "",
        savings: "",
      },
      TRANSLATION_KEY: "steps.RiskAssessment",
      formIsValid: false
    };
  },
  mounted(): void {
    this.$store.commit(SET_PROGRESS, 4);
    this.isValid()
    setInterval(this.isValid, 100)
  },
  methods: {
    isValid() {
      const customSelects = document.querySelectorAll('.custom-select-wrapper .custom-select');
      const selectsLength = customSelects.length
      let validSelectsLength = 0
      customSelects.forEach(select => {
        if (select.classList.contains('valid')) {
          validSelectsLength++
        }
        if (validSelectsLength === selectsLength) {
        this.formIsValid = true
        } else {
          this.formIsValid = false
        }
      })
    },  
  },
  computed: {
    employmentStatus(): FieldInterface[] {
      return [
        {
          key: EmploymentStatus.EMPLOYED,
          value: this.$t("steps.RiskAssessment.employed"),
        },
        {
          key: EmploymentStatus.SELF_EMPLOYED,
          value: this.$t("steps.RiskAssessment.selfEmployed"),
        },
        {
          key: EmploymentStatus.BUSINESS_OWNER,
          value: this.$t("steps.RiskAssessment.businessOwner"),
        },
        {
          key: EmploymentStatus.UNEMPLOYED,
          value: this.$t("steps.RiskAssessment.unemployed"),
        },
        {
          key: EmploymentStatus.RETIRED,
          value: this.$t("steps.RiskAssessment.retired"),
        },
        {
          key: EmploymentStatus.STUDENT_EMPLOYED,
          value: this.$t("steps.RiskAssessment.studentEmployed"),
        },
        {
          key: EmploymentStatus.STUDENT_UNEMPLOYED,
          value: this.$t("steps.RiskAssessment.studentUnemployed"),
        },
      ] as FieldInterface[];
    },
    natureOfBusiness(): FieldInterface[] {
      return [
        {
          key: NatureOfBusiness.AGRICULTURAL,
          value: this.$t("steps.RiskAssessment.businessAgricultural"),
        },
        {
          key: NatureOfBusiness.EDUCATION,
          value: this.$t("steps.RiskAssessment.businessEducation"),
        },
        {
          key: NatureOfBusiness.SOCIAL_SERVICES_HEALTH,
          value: this.$t("steps.RiskAssessment.businessSocialServices"),
        },
        {
          key: NatureOfBusiness.FINANCIAL_LEGAL_ACCOUNTING,
          value: this.$t("steps.RiskAssessment.businessFinancialLegalAccounting"),
        },
        {
          key: NatureOfBusiness.RETAIL_SERVICES,
          value: this.$t("steps.RiskAssessment.businessRetailServices"),
        },
        {
          key: NatureOfBusiness.ADMINISTRATIVE,
          value: this.$t("steps.RiskAssessment.businessAdministrative"),
        },
        {
          key: NatureOfBusiness.INSURANCE_SERVICE,
          value: this.$t("steps.RiskAssessment.businessInsuranceService"),
        },
        {
          key: NatureOfBusiness.ENGINEERING_IT_TECHNOLOGY,
          value: this.$t("steps.RiskAssessment.businessEngineeringItTechnology"),
        },
        {
          key: NatureOfBusiness.RESTAURANTS,
          value: this.$t("steps.RiskAssessment.businessRestaurants"),
        },
        {
          key: NatureOfBusiness.TRANSPORT_LOGISTICS,
          value: this.$t("steps.RiskAssessment.businessTransportLogistics"),
        },
        {
          key: NatureOfBusiness.AUTOMOTIVE,
          value: this.$t("steps.RiskAssessment.businessAutomotive"),
        },
        {
          key: NatureOfBusiness.CASINO_BETTING,
          value: this.$t("steps.RiskAssessment.businessCasinoBettings"),
        },
        {
          key: NatureOfBusiness.NON_PROFIT_CHARITY,
          value: this.$t("steps.RiskAssessment.businessNonProfitCharity"),
        },
        {
          key: NatureOfBusiness.DEFENCE_MILITARY_AEROSPACE,
          value: this.$t("steps.RiskAssessment.businessDefenceMilitaryAerospace"),
        },
        {
          key: NatureOfBusiness.LEISURE_TOURISM,
          value: this.$t("steps.RiskAssessment.businessLeisureTourism"),
        },
        {
          key: NatureOfBusiness.MINING_NATURAL_RESOURCES_OIL,
          value: this.$t("steps.RiskAssessment.businessMiningNaturalResourcesOil"),
        },
        {
          key: NatureOfBusiness.PHARMACEUTICALS_BIOTECH,
          value: this.$t("steps.RiskAssessment.businessPharmaceuticalsBiotech"),
        },
        {
          key: NatureOfBusiness.PROPERTY_CONSTRUCTION,
          value: this.$t("steps.RiskAssessment.businessPropertyConstruction"),
        },
        {
          key: NatureOfBusiness.EXPORT_IMPORT,
          value: this.$t("steps.RiskAssessment.businessExportImport"),
        },
        {
          key: NatureOfBusiness.SALE_DISTRIBUTION_ALCOHOL_TOBACCO,
          value: this.$t("steps.RiskAssessment.businessSaleAlcoholTobacco"),
        },
        {
          key: NatureOfBusiness.MANUFACTURING,
          value: this.$t("steps.RiskAssessment.businessManufacturing"),
        },
        {
          key: NatureOfBusiness.MARKETING,
          value: this.$t("steps.RiskAssessment.businessMarketing"),
        },
      ] as FieldInterface[];
    },
    role(): FieldInterface[] {
      return [
        {
          key: Role.JUNIOR,
          value: this.$t("steps.RiskAssessment.junior"),
        },
        {
          key: Role.MID,
          value: this.$t("steps.RiskAssessment.mid"),
        },
        {
          key: Role.SENIOR,
          value: this.$t("steps.RiskAssessment.senior"),
        },
        {
          key: Role.MANAGER_DIRECTOR,
          value: this.$t("steps.RiskAssessment.managerDirector"),
        },
        {
          key: Role.CONTRACTOR,
          value: this.$t("steps.RiskAssessment.contractor"),
        },
      ] as FieldInterface[];
    },
    sourceOfFunds(): FieldInterface[] {
      let values = [];
      values = [
        {
          key: SourceOfFunds.EMPLOYMENT_INCOME,
          value: this.$t("steps.RiskAssessment.employmentIncome"),
        },
        {
          key: SourceOfFunds.BUSINESS_ACTIVITY,
          value: this.$t("steps.RiskAssessment.businessActivity"),
        },
        {
          key: SourceOfFunds.PENSION,
          value: this.$t("steps.RiskAssessment.pension"),
        },
        {
          key: SourceOfFunds.SAVINGS_INVESTMENTS,
          value: this.$t("steps.RiskAssessment.savingsInvestments"),
        },
        {
          key: SourceOfFunds.GRANTS_LOANS,
          value: this.$t("steps.RiskAssessment.grantsLoans"),
        },
      ] as FieldInterface[];
      if (
        this.formData.employmentStatus == "UNEMPLOYED" ||
        this.formData.employmentStatus == "STUDENT_WITHOUT_EMPLOYMENT"
      ) {
        return values.slice(2);
      } else {
        return values;
      }
    },
    income(): FieldInterface[] {
      return [
        {
          key: Income.EUR0,
          value: this.$t("steps.RiskAssessment.bracketOne"),
        },
        {
          key: Income.EUR10,
          value: this.$t("steps.RiskAssessment.bracketTwo"),
        },
        {
          key: Income.EUR16,
          value: this.$t("steps.RiskAssessment.bracketThree"),
        },
        {
          key: Income.EUR30,
          value: this.$t("steps.RiskAssessment.bracketFour"),
        },
        {
          key: Income.EUR60,
          value: this.$t("steps.RiskAssessment.bracketFive"),
        },
        {
          key: Income.EUR100,
          value: this.$t("steps.RiskAssessment.bracketSix"),
        },
        {
          key: Income.EUR250,
          value: this.$t("steps.RiskAssessment.bracketSeven"),
        },
      ] as FieldInterface[];
    },
    savings(): FieldInterface[] {
      return [
        {
          key: Savings.EUR0,
          value: this.$t("steps.RiskAssessment.bracketOne"),
        },
        {
          key: Savings.EUR10,
          value: this.$t("steps.RiskAssessment.bracketTwo"),
        },
        {
          key: Savings.EUR16,
          value: this.$t("steps.RiskAssessment.bracketThree"),
        },
        {
          key: Savings.EUR30,
          value: this.$t("steps.RiskAssessment.bracketFour"),
        },
        {
          key: Savings.EUR60,
          value: this.$t("steps.RiskAssessment.bracketFive"),
        },
        {
          key: Savings.EUR100,
          value: this.$t("steps.RiskAssessment.bracketSix"),
        },
        {
          key: Savings.EUR250,
          value: this.$t("steps.RiskAssessment.bracketSeven"),
        },
      ] as FieldInterface[];
    },
  },
  watch: {
    "formData.employmentStatus"() {
      if (
          this.formData.employmentStatus === EmploymentStatus.UNEMPLOYED ||
          this.formData.employmentStatus === EmploymentStatus.RETIRED ||
          this.formData.employmentStatus === EmploymentStatus.STUDENT_UNEMPLOYED
          ) 
        {
        this.formData.natureOfBusiness = "",
        this.formData.position = ""
      }
    }
  },
  components: {
    Popup,
    Select,
    SubmitButton,
  },
});
